var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_37730",
    "data-name": "Group 37730",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.426,
    height: 36,
    viewBox: "0 0 20.426 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38198",
    "data-name": "Path 38198",
    d: "M7.787,3.064h2.426a.684.684,0,0,0,.638-.638.6.6,0,0,0-.638-.638H7.787a.684.684,0,0,0-.638.638A.82.82,0,0,0,7.787,3.064Zm4.213,0h.638c.255,0,.511-.383.511-.638a.584.584,0,0,0-.511-.638H12a.6.6,0,0,0-.638.638A.684.684,0,0,0,12,3.064Zm7.149,22.6v0Zm1.277,0V2.681A2.618,2.618,0,0,0,17.745,0H2.681A2.618,2.618,0,0,0,0,2.681V33.319A2.618,2.618,0,0,0,2.681,36H17.745a2.618,2.618,0,0,0,2.681-2.681Zm-1.277,0v1.915h-18V4.851h18ZM2.681,1.149H17.745a1.449,1.449,0,0,1,1.4,1.532v.894h-18V2.681A1.475,1.475,0,0,1,2.681,1.149Zm15.064,33.7H2.681a1.475,1.475,0,0,1-1.532-1.532V28.851h18v4.468A1.449,1.449,0,0,1,17.745,34.851Zm-7.532-5.489a2.511,2.511,0,0,0-2.426,2.426,2.426,2.426,0,0,0,4.851,0A2.511,2.511,0,0,0,10.213,29.362Zm0,3.7a1.259,1.259,0,0,1-1.149-1.277,1.149,1.149,0,0,1,2.3,0A1.259,1.259,0,0,1,10.213,33.064Z",
    fill: "#282828",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.605c222df8f48b31cc0c8c49eb6f6fba.svg";
export { ForwardRef as ReactComponent };